import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Switch, Redirect, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import './index.css';

import HomeLayout from "./components/UI/Layouts/HomeLayout";
import GrowerReceiptPage from "./components/UI/Pages/ViewReceipt/GrowerReceiptPage";

ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route key="r" path="/r/:receiptid" exact render={props => <GrowerReceiptPage {...props}/>} />
      <Route key="home" path="/home" render={props => <HomeLayout {...props}/>} />
      <Redirect from="/" to="/home" />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();



